export const DATETIME_QUERY_PARAMS = new Set(['from', 'to', 'compareFrom', 'compareTo']);

export const normalizeDateTimeQueryValue = (param: string, value: unknown) => {
  if (!DATETIME_QUERY_PARAMS.has(param)) return value;
  if (value == null || value === '') return value;
  if (typeof value !== 'string') return value;
  if (value.length !== 16) return value;

  if (param === 'to' || param === 'compareTo') {
    return value + ':59';
  }

  return value + ':00';
};

export const normalizeDateTimeQueryParams = (params: Record<string, unknown>) => {
  const normalized = { ...params };

  for (const param of DATETIME_QUERY_PARAMS) {
    if (param in normalized) {
      normalized[param] = normalizeDateTimeQueryValue(param, normalized[param]);
    }
  }

  return normalized;
};
